import { useProductFileAttributeUpdateMutation } from "@dashboard/graphql";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { useStorageUpload } from "@dashboard/utils/storage";
import { useIntl } from "react-intl";

export function useProductAttributeFileStorageUploadUpdate(
  productId: string,
  onSuccess: () => void,
): [
  (attributeId: string, file: File) => Promise<void>,
  {
    loading: boolean;
  },
] {
  const intl = useIntl();
  const notify = useNotifier();
  const [updateProductFileAttribute, updateProductFileAttributeOpts] =
    useProductFileAttributeUpdateMutation({
      onCompleted: data => {
        if (data.productUpdate?.errors.length === 0) {
          onSuccess();
          notify({
            status: "success",
            text: intl.formatMessage(commonMessages.savedChanges),
          });
        } else {
          notify({
            status: "success",
            text: intl.formatMessage(commonMessages.error),
          });
        }
      },
    });
  const [updateWithStorageUpload, updateWithStorageUploadOpts] = useStorageUpload(
    async (attributeId, fileUrl, contentType) => {
      await updateProductFileAttribute({
        variables: { productId, attributeId, fileUrl, contentType },
      });
    },
  );

  const options = {
    loading: updateProductFileAttributeOpts.loading || updateWithStorageUploadOpts.loading,
  };

  return [updateWithStorageUpload, options];
}
